<template>
  <div class="modal fade" id="createRegionModal" tabindex="-2" role="dialog">
    <div class="modal-dialog  modal-dialog-centered" role="document">
      <div class="modal-content">
        <form @submit="submitForm" class="needs-validation" novalidate>
          <div class="modal-body createForm">
            <h2>建立區域</h2>
            <div class="form-group row">
              <label class="col-sm-5 col-form-label" for="regionName">
                區域名稱
                <span>(使用者可以修改)</span>
                :
              </label>
              <div class="col-sm-7">
                <input type="text" class="form-control" id="regionName" v-model="region_name" required>
              </div>
            </div>
            <div class="form-group row">
              <label class="col-sm-5 col-form-label" for="alias">
                區域別名<span>(只有後台可以看見)</span>:
              </label>
              <div class="col-sm-7">
                <input type="text" class="form-control" id="alias" v-model="alias">
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">取消</button>
            <button type="submit" class="btn btn-success">新增區域</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      region_name: '',
      mac: '',
      alias: '',
      user: '',
      base_url,
      macAddressError: false // 儲存驗證錯誤狀態
    }
  },
  methods: {
    submitForm() {
      const create_region_form = {
        name: this.region_name,
        location_id: '128',
        bx_alias: this.alias,
      };
      axios.post(base_url + '/api/regions', create_region_form)
        .then(response => {
          const region_id = response.data.id
          this.regionName = '';
          this.alias = '';
          if (this.user) {
            this.addUserIntoRegion(region_id);
          }
          if (this.mac) {
            this.addMacIntoRegion(region_id);
          }
        })
        .catch(error => { console.error('Error adding region:', error); });
    },
    addUserIntoRegion(region_id) {
      const add_user_into_region = {
        account: this.user,
        role_id: 3,
        region_id: region_id,
      };
      axios.post(base_url + '/api/share/region', add_user_into_region)
        .then(response => {
          this.user = '';
        })
        .catch(error => { console.error('Error adding mac into region:', error); })
    },
    addMacIntoRegion(region_id) {
      const add_mac_into_region = {
        bx_mac: this.mac,
        region_id: region_id,
      };
      axios.post(base_url + '/api/bx', add_mac_into_region)
        .then(response => {
          if (response.data.message === 'This mac has been used') {
            alert('這個 mac address 已被加入其他區域中。')
          } else if (response.data.message === 'This mac address does not exist') {
            alert('這個 mac address 不存在。')
          }
          this.mac = '';
        })
        .catch(error => { console.error('Error adding mac into region:', error); })
    },
  },
  directives: {
    'mac-address': {
      bind(el, binding, vnode) {
        el.addEventListener('input', () => {
          const macRegex = /^([0-9A-Fa-f]{2}:){5}[0-9A-Fa-f]{2}$/;
          const isValid = macRegex.test(el.value);
          vnode.context.macAddressError = !isValid;
        });
      }
    }
  }
}
</script>

<style>
.createForm div label span {
  font-size: 12px;
  color: gray;
}
</style>
